import { render, staticRenderFns } from "./PhysicalCardIndex.vue?vue&type=template&id=166399b7&scoped=true"
import script from "./PhysicalCardIndex.vue?vue&type=script&lang=js"
export * from "./PhysicalCardIndex.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCardIndex.vue?vue&type=style&index=0&id=166399b7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166399b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166399b7')) {
      api.createRecord('166399b7', component.options)
    } else {
      api.reload('166399b7', component.options)
    }
    module.hot.accept("./PhysicalCardIndex.vue?vue&type=template&id=166399b7&scoped=true", function () {
      api.rerender('166399b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/PhysicalCardIndex.vue"
export default component.exports